import { FormattedMessage } from 'react-intl'
import Collapse from 'react-collapse'

import ReviewAddForm from './ReviewForm'

const ReviewAddContainer = ({ isOpen, afterSubmit, isPositive }) => {
  return (
    <Collapse isOpened={isOpen}>
      <div className='reviews__collapse-container'>
        <h3 className='reviews-collapse__title mbm'>
          <FormattedMessage
            defaultMessage='Thanks for your review!'
            id='reviews.dive_site.thanks_for_review'
          />
        </h3>
        <p className='reviews-collapse__subtitle'>
          <FormattedMessage
            defaultMessage='Help divers decide if this site is for them: add a comment.'
            id='reviews.dive_site.help_divers'
          />
        </p>
        <ReviewAddForm isPositive={isPositive} afterSubmit={afterSubmit} />
      </div>
    </Collapse>
  )
}

export default ReviewAddContainer
